import { define } from 'wicked-elements'

define('[data-component="home-jump-button"]', {
  init() {
    this.handleClick = this.handleClick.bind(this)
    this.$about = document.getElementById('about')
  },
  connected() {
    this.element.addEventListener('click', this.handleClick)
  },
  disconnected() {
    this.element.removeEventListener('click', this.handleClick)
  },
  handleClick() {
    this.$about.scrollIntoView({ behavior: 'smooth' })
  }
});